import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

/**
 * Shown in place of the repayment steps while a loan's quote is quarantined, so
 * the disabled button and the `--` amounts read as a known outage rather than a
 * loading state or a zero balance. See quarantinedQuotes.ts.
 */
export function QuoteUnavailableNote() {
  return (
    <div className="flex items-start gap-3 my-4 text-sm text-text-secondary">
      <ExclamationTriangleIcon className="size-5 shrink-0 text-yellow-400" />
      {/* Deliberately reason-neutral: `quarantinedQuotes.ts` now covers two different causes
          (a broken onchain quote and an operational hold), and naming only one of them would
          state something untrue to the borrower for the other. */}
      <span>
        Payments for this loan are temporarily paused, so payment amounts are unavailable. Please contact us if you have
        any questions.
      </span>
    </div>
  );
}
